import NL from "./nl/translation.json";
import FR from "./fr/translation.json";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const userLang = navigator.language.substr(0, 2) === "fr" ? "fr" : "nl";

i18next.use(initReactI18next).init({
    resources: {
        fr: { translation: FR },
        nl: { translation: NL },
    },
    lng: userLang,
    interpolation: {
        escapeValue: false,
    },
    fallbackLng: "nl",
});

export default i18next;
